import { constants } from 'lib_ui-services';
const { useCaseIds } = constants;

export default {
    verb: 'doingCopy',
    namespace: 'deploy',
    relation: 'deployment',
    useCaseIds: [useCaseIds.ONE_TOUCH],
    description: 'Remove some things added server side which are not needed on the client side.',
    priority: -10,
    //this is the actual logic:
    logic: doingCopy
};

/**
 * Prepares a persisted deployment record for a new One Touch submission.
 *
 * This mutates `data.record`: it resets status, reduces saved selections to the
 * identifiers and titles accepted by the form, clears stale route-selection
 * state for normal copies, and removes credentials so the user must enter them
 * again. Explicit emergency targets remain selected. Missing required selection
 * records fail while their minimized form values are built.
 *
 * @param {{ data: { record: object } }} parameters
 * @returns {object} The same data object containing the prepared record.
 */
function doingCopy({ data }) {
    const { record } = data;
    record.status = 'new';

    const requestedEnvironment = record['deploy:requestedEnvironment'];
    if (requestedEnvironment) {
        record['deploy:requestedEnvironment'] = minimizeSelection(requestedEnvironment);
    }

    // A normal copy preserves the requested logical Environment but clears the
    // previous Deployment Target and route state so validation can select the
    // current inactive target. Explicit overrides and established records
    // without deploy:requestedEnvironment retain a minimized deploy:environment.
    if (record['deploy:requestedEnvironment'] && !record.targetOverride) {
        delete record['deploy:environment'];
        delete record.routeSelectedTarget;
        delete record.targetOverride;
    } else {
        const target = record['deploy:environment'];
        record['deploy:environment'] = minimizeSelection(target);
    }

    // An emergency copy keeps the selected target, but the user must enter the
    // database password and accept the emergency warning again.
    delete record.databasePassword;
    delete record.databasePasswordConfirmation;
    delete record.rabbitmqErlangCookie;
    delete record.rabbitmqPassword;

    const releaseGroups = record.releaseGroups;
    releaseGroups.forEach(rg => {
        let release = rg['deploy:release'];
        release = {
            _id: release._id,
            title: release.title
        };
        rg['deploy:release'] = release;
    });
    return data;
}

/**
 * Keeps the identifier and display title needed by form controls while removing
 * server-expanded fields that would fail POST validation.
 *
 * @param {object} selection
 * @returns {{ _id: *, title: * }}
 * @throws {TypeError} If no selection was supplied.
 */
function minimizeSelection(selection) {
    return { _id: selection._id, title: selection.title };
}
